import { createGenericListItemReducer } from "common/genericListItemReducer";
import reduceReducers from "reduce-reducers";
import {
  IS_WIDGET_SUPPORTED_RECEIVED,
  IS_WIDGET_SUPPORTED_REQUESTED,
  IS_WIDGET_SUPPORTED_REQUEST_FAILED,
  WIDGET_CREATION_RECEIVED,
  WIDGET_CREATION_REQUESTED,
  WIDGET_CREATION_REQUEST_FAILED
} from "./widgetActions";

export const widget = reduceReducers(
  createGenericListItemReducer(
    IS_WIDGET_SUPPORTED_REQUESTED,
    IS_WIDGET_SUPPORTED_RECEIVED,
    IS_WIDGET_SUPPORTED_REQUEST_FAILED
  ),
  createGenericListItemReducer(WIDGET_CREATION_REQUESTED, WIDGET_CREATION_RECEIVED, WIDGET_CREATION_REQUEST_FAILED)
);
